import { Box, Paper, Skeleton } from "@mui/material";
import PercentRangesChart from "./PercentRangesChart";
import useSWR from "swr";
import NotFound from "../../../../components/notfound/NotFound";
import { fetchData } from "../../../../lib/dashboard/data";

const PercentRanges = () => {

    const { data = [], isLoading } = useSWR(
        "/dashboard/percent-ranges",
        fetchData,
        {
            revalidateOnFocus: false,
            dedupingInterval: 60 * 1000,
        }
    );

    return <Paper sx={{ height: 400 }}>
        {isLoading ? <Skeleton height="100%" variant="rounded" />
            : !data || data.length === 0 ? (
                <Box sx={{ margin: "auto", height: "100%" }}>
                    <NotFound />
                </Box>
            ) :
                <PercentRangesChart data={data} />
        }
    </Paper>
};

export default PercentRanges;